Pluswerk.PlusProject.Utility.JumpToSectionController = function () {
    var target = $(':target');
    if(target.length){
        var offset = target.offset();
        var scrollto = offset.top - 30; // minus fixed header height
        $('html, body').animate({scrollTop:scrollto}, 0);
    }
};
